const links = document.querySelectorAll('#subnavigation a');
const mapElement = document.querySelector('#map');

// Default to "New York" on page load
if (!window.location.hash) {
	const defaultLocation = '#New-York';
	window.location.hash = defaultLocation;
}

let map = null;

setActiveBasedOnHash(window.location.hash);
setMapLocation(window.location.hash);

window.addEventListener('hashchange', () => {
	const { hash } = window.location;
	setActiveBasedOnHash(hash);
	setMapLocation(hash);
});

function setActiveBasedOnHash(hash) {
	if (hash) {
		const link = document.querySelector(`[href="${hash}"]`);

		if (link) {
			links.forEach(link => link.classList.remove('active'));
			link.classList.add('active');
		}
	}
}

function setMapLocation(hash) {
	const { lat, lon } = document.querySelector(hash).dataset;

	if(!lat || !lon){
		mapElement.classList.add('hidden');
		return;
	} else {
		mapElement.classList.remove('hidden');
	}

	if (map === null) {
		initMap(lat, lon);
	}

	const newCenter = new google.maps.LatLng(lat, lon);
	marker.setPosition(newCenter);
	map.panTo(newCenter);
}

function initMap(lat, lon) {
	map = new google.maps.Map(mapElement, {
		zoom: 15,
		center: new google.maps.LatLng(lat, lon),
		styles: [
			{
				featureType: 'administrative',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#444444'
					}
				]
			},
			{
				featureType: 'landscape',
				elementType: 'all',
				stylers: [
					{
						color: '#f2f2f2'
					}
				]
			},
			{
				featureType: 'poi',
				elementType: 'all',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'poi',
				elementType: 'labels.text',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road',
				elementType: 'all',
				stylers: [
					{
						saturation: -100
					},
					{
						lightness: 45
					}
				]
			},
			{
				featureType: 'road.highway',
				elementType: 'all',
				stylers: [
					{
						visibility: 'simplified'
					}
				]
			},
			{
				featureType: 'road.arterial',
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'transit',
				elementType: 'all',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'water',
				elementType: 'all',
				stylers: [
					{
						color: '#dbdbdb'
					},
					{
						visibility: 'on'
					}
				]
			}
		]
	});

	marker = new google.maps.Marker({
		position: new google.maps.LatLng(lat, lon),
		map: map,
		title: 'ATP',
		icon: {
			path: 'M 0, 0 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0',
			fillColor: '#FF3F16',
			fillOpacity: 1,
			strokeColor: '#FF3F16',
			strokeWeight: 2,
			scale: 1,
		}
	});

	map.setOptions({
		draggable: true,
		zoomControl: true,
		scrollwheel: false,
		disableDoubleClickZoom: true,
		streetViewControl: false,
		disableDefaultUI: true
	});

	google.maps.event.addDomListener(window, 'resize', function () {
		const center = map.getCenter();
		google.maps.event.trigger(map, 'resize');
		map.setCenter(center);
	});
}
